import { TFunction } from 'i18next';
import { CardId } from 'components/HomeComponent/cards/types';
import { CAPTURE_STAT_CARD_IDS } from 'components/HomeComponent/cards/capture-stat-card-config';

export const isCaptureStatCardId = (cardId: CardId): boolean =>
  CAPTURE_STAT_CARD_IDS.includes(cardId);

export const getCaptureStatCardTitle = (
  cardId: CardId,
  t: TFunction
): string => {
  switch (cardId) {
    case 'capturePendingReview':
      return t('organisation.transactions-view-tab-pending-review');
    case 'captureReadyToPost':
      return t('organisation.capture-dashboard-awaiting-post');
    case 'capturePostedFiles':
      return t('organisation.capture-dashboard-posted-month');
    case 'captureFilesUploaded':
      return t('organisation.capture-dashboard-documents-processed');
    default:
      return '';
  }
};

export const getCaptureStatCardDescription = (
  cardId: CardId,
  t: TFunction
): string => {
  switch (cardId) {
    case 'capturePendingReview':
      return t('organisation.capture-dashboard-pending-review-desc');
    case 'captureReadyToPost':
      return t('organisation.capture-dashboard-awaiting-post-desc');
    case 'capturePostedFiles':
      return t('organisation.capture-dashboard-posted-month-desc');
    case 'captureFilesUploaded':
      return t('organisation.capture-dashboard-documents-processed-desc');
    default:
      return '';
  }
};
